export const ConfettiColors = ['#E84F55', '#E85855', '#E86055', '#E86955', '#E87155']
